import Categories from '../../../page-fragments/category/categories/Categories';
import categoryContextProvider from '../../../page-fragments/category/category-context-provider/CategoryContextProvider';
import CategoryDetails from '../../../page-fragments/category/category-details/CategoryDetails';
import CategoryImage from '../../../page-fragments/category/category-image/CategoryImage';
import CategoryLinks from '../../../page-fragments/category/category-links/CategoryLinks';
import renderer from '../../renderer';
import { categoryAttributes } from '../../../constants/categories';
import { useEffect } from 'react';
import {
  GenericRendererComponent,
  RendererComponentType,
  RendererSelectorType,
} from '../../../types/renderer';

export const componentsRegister: GenericRendererComponent[] = [
  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.ATTRIBUTE,
    selector: `[${categoryAttributes.keys.elementType}="${categoryAttributes.values.categoryImage}"]`,
    component: ({ data_parent_slug, data_card_index }) => {
      const ComponentWithContext = categoryContextProvider(CategoryImage);
      return (
        data_parent_slug &&
        data_card_index && (
          <ComponentWithContext
            parentCategorySlug={data_parent_slug}
            cardIndex={data_card_index}
            updateCategoryCardHref={true}
          />
        )
      );
    },
  },
  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.ATTRIBUTE,
    selector: `[${categoryAttributes.keys.elementType}="${categoryAttributes.values.categoryDetails}"]`,
    component: ({ data_parent_slug, data_card_index }) => {
      const ComponentWithContext = categoryContextProvider(CategoryDetails);
      return (
        data_parent_slug &&
        data_card_index && (
          <ComponentWithContext parentCategorySlug={data_parent_slug} cardIndex={data_card_index} />
        )
      );
    },
  },
  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.ATTRIBUTE,
    selector: `[${categoryAttributes.keys.elementType}="${categoryAttributes.values.categoryLinks}"]`,
    component: ({ data_slug }) => {
      return data_slug && <CategoryLinks slug={data_slug} />;
    },
  },
  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.ATTRIBUTE,
    selector: `[${categoryAttributes.keys.elementType}="${categoryAttributes.values.moreCategories}"]`,
    component: ({ data_page_size, data_page_offset, data_number_of_subcategories }) => {
      return (
        data_page_size &&
        data_page_offset &&
        data_number_of_subcategories && (
          <Categories
            pageSize={data_page_size}
            pageOffset={data_page_offset}
            numberOfSubcategories={data_number_of_subcategories}
          />
        )
      );
    },
  },
];

function Category() {
  useEffect(() => {
    renderer(componentsRegister);
  }, []);

  return null;
}

export default Category;
